/* MIEN — shared Supabase client + helpers (window.MIEN).
   Anon/publishable key is safe to expose; RLS protects the data. */
window.MIEN = (function () {
  var URL = 'https://auofatogulzlugpffwst.supabase.co';
  var KEY = 'sb_publishable_sFOQcQJVJHvX-3zV1spZDg_Hi0D-5fC';
  var sb = (window.supabase && window.supabase.createClient)
    ? window.supabase.createClient(URL, KEY, { auth: { persistSession: true, autoRefreshToken: true } })
    : null;

  function ready() { return !!sb; }

  async function session() {
    if (!sb) return null;
    var r = await sb.auth.getSession();
    return (r && r.data) ? r.data.session : null;
  }
  async function user() {
    var s = await session();
    return s ? s.user : null;
  }
  /* where a signup came from, saved on the profile by the database: the campaign link that brought
     them here last (kept 30 days), else first-touch attribution. one touch is one unit: source and
     campaign both come from the same visit, so an empty field is never filled from another link
     (clip turns '' into null). an ?invite= code rides along for attribution only; nothing requires it.
     exposed as MIEN.signupMeta so onboarding files its events under the same campaign. */
  function signupMeta(opts) {
    var a = {}, last = null, inv = (opts && opts.invite) || '';
    try { a = attribution() || {}; } catch (e) {}
    try { last = JSON.parse(localStorage.getItem('fly_signup_utm') || 'null'); } catch (e) {}
    if (last && Date.now() - (last.at || 0) > 30 * 864e5) last = null;
    try { inv = inv || localStorage.getItem('fly_invite') || ''; } catch (e) {}
    var src = last ? last.source : (a.utm_source || a.channel);
    var camp = last ? last.campaign : a.utm_campaign;
    return { signup_source: clip(src, 80), signup_campaign: clip(camp, 120), invite: clip(inv, 80) };
  }
  function signUp(email, password, opts) {
    return sb.auth.signUp({ email: email, password: password,
      options: { emailRedirectTo: window.location.origin + '/pages/account', data: signupMeta(opts) } })
      /* 'signup' has always been an allowed event_type but nothing ever fired it, so the
         deepest conversion the site has was invisible. logged only on success, and the
         result is passed straight through so callers are unaffected. */
      .then(function (r) {
        if (r && !r.error) { try { logEvent('signup'); } catch (e) {} }
        return r;
      });
  }
  function signIn(email, password) { return sb.auth.signInWithPassword({ email: email, password: password }); }
  /* signing out also gives this browser a fresh fly visitor key, so the next person on a shared
     device does not get a feed shaped by what the last one opened */
  function signOut() {
    try { if (window.MIEN && window.MIEN.flyFlush) window.MIEN.flyFlush(); } catch (e) {}
    try {
      var k = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem('fly_vk', k); sessionStorage.setItem('fly_sk', k); sessionStorage.removeItem('fly_seed');
      /* the onboarding taste lives on the profile for members; the local copy would keep ranking for whoever is next */
      localStorage.removeItem('fly_taste_picks'); localStorage.removeItem('fly_pending_onb');
    } catch (e) {}
    return sb.auth.signOut();
  }
  /* password reset — send the recovery email. redirectTo MUST be on the Supabase
     Auth redirect allowlist (https://bemien.com/pages/reset, and the same path on every
     domain pointed at the store, e.g. howtogetfly.com) or the link bounces. */
  function resetPassword(email) {
    if (!sb) return Promise.resolve({ error: { message: 'not ready' } });
    return sb.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin + '/pages/reset' });
  }
  /* set a new password for the current (recovery) session → /pages/reset */
  function updatePassword(password) {
    if (!sb) return Promise.resolve({ error: { message: 'not ready' } });
    return sb.auth.updateUser({ password: password });
  }
  function onChange(cb) { if (sb) sb.auth.onAuthStateChange(function (_e, s) { cb(s); }); }

  /* ---------------------------------------------------------------------------
     OUTLET PRICING — members only, and that is enforced on the server.
     A lane:outlet piece is rendered by the theme with no price anywhere in the
     markup. This is the only way to get one, and the outlet-price edge function
     answers it only for a token that resolves to a real user — the publishable
     key below is NOT enough, by design.
     Returns { handle: { price_cents, compare_at_cents, msrp_cents, discount_pct,
                         available, lane, variants[] } }, or {} for a signed-out
     caller (we do not even make the request — there is nothing to gain from a 401
     round trip on every feed paint).
     --------------------------------------------------------------------------- */
  async function outletPrices(handles) {
    if (!sb || !handles || !handles.length) return {};
    var s = await session();
    var tok = s && s.access_token;
    if (!tok) return {};
    var out = {};
    for (var i = 0; i < handles.length; i += 200) {   /* the function caps at 250 */
      var chunk = handles.slice(i, i + 200);
      try {
        var r = await fetch(URL + '/functions/v1/outlet-price', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'apikey': KEY, 'Authorization': 'Bearer ' + tok },
          body: JSON.stringify({ handles: chunk })
        });
        if (!r.ok) continue;
        var j = await r.json();
        if (j && j.prices) Object.keys(j.prices).forEach(function (k) { out[k] = j.prices[k]; });
      } catch (e) {}
    }
    return out;
  }

  async function profile() {
    var u = await user();
    if (!u) return null;
    /* email is read from the session, not the table: profiles.email is no longer selectable from the
       browser (2026-10-23), since profiles is public and that exposed every member's address */
    var sel = 'id, member_no, handle, display_name, avatar_url, created_at, onboarded_at, style_niches, onboarding_completed_at, style_picks';
    var r = await sb.from('profiles').select(sel).eq('id', u.id).maybeSingle();
    if (r && r.data) { r.data.email = u.email; return r.data; }
    // fallback if the auto-create trigger hasn't run yet
    try { await sb.from('profiles').insert({ id: u.id, email: u.email }); } catch (e) {}
    var r2 = await sb.from('profiles').select(sel).eq('id', u.id).maybeSingle();
    if (r2 && r2.data) r2.data.email = u.email;
    return (r2 && r2.data) ? r2.data : null;
  }
  /* first-run onboarding (mien-onboarding snippet) — reads/writes the caller's OWN row.
     onboardingState() is a light read (no insert-fallback); writes reuse setProfile(). */
  async function onboardingState() {
    var u = await user(); if (!u) return null;
    var r = await sb.from('profiles').select('onboarding_completed_at, style_picks').eq('id', u.id).maybeSingle();
    return (r && r.data) ? r.data : null;
  }
  async function setHandle(handle) {
    var u = await user();
    if (!u) return { error: { message: 'not signed in' } };
    return sb.from('profiles').update({ handle: handle }).eq('id', u.id);
  }
  async function setProfile(fields) {          /* update own row: display_name, avatar_url, handle */
    var u = await user();
    if (!u) return { error: { message: 'not signed in' } };
    return sb.from('profiles').update(fields).eq('id', u.id);
  }
  async function uploadAvatar(file) {          /* → public avatars bucket at {uid}/{name}; returns { url, error } */
    var u = await user();
    if (!u || !file) return { error: { message: 'not signed in' } };
    var ext = (file.name && file.name.indexOf('.') > -1) ? file.name.split('.').pop().toLowerCase().replace(/[^a-z0-9]/g, '') : 'jpg';
    var path = u.id + '/avatar-' + Date.now() + '.' + (ext || 'jpg');
    var up = await sb.storage.from('avatars').upload(path, file, { cacheControl: '3600', upsert: true, contentType: file.type || undefined });
    if (up && up.error) return { error: up.error };
    var pub = sb.storage.from('avatars').getPublicUrl(path);
    return { url: (pub && pub.data) ? pub.data.publicUrl : null };
  }

  async function counts(gids) {
    if (!sb) return {};
    var q = sb.from('highlight_counts').select('highlight_gid, save_count, reaction_count');
    if (gids && gids.length) q = q.in('highlight_gid', gids);
    var r = await q;
    var map = {};
    (r && r.data ? r.data : []).forEach(function (row) { map[row.highlight_gid] = row; });
    return map;
  }
  async function mySaves() {
    var u = await user(); if (!u) return [];
    var r = await sb.from('saves').select('highlight_gid').eq('user_id', u.id);
    return (r && r.data ? r.data : []).map(function (x) { return x.highlight_gid; });
  }
  async function myReactions() {
    var u = await user(); if (!u) return [];
    var r = await sb.from('reactions').select('highlight_gid').eq('user_id', u.id).eq('type', 'like');
    return (r && r.data ? r.data : []).map(function (x) { return x.highlight_gid; });
  }
  async function toggleSave(gid, on) {
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    if (on) return sb.from('saves').insert({ user_id: u.id, highlight_gid: gid });
    return sb.from('saves').delete().eq('user_id', u.id).eq('highlight_gid', gid);
  }
  async function toggleReaction(gid, on) {
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    if (on) return sb.from('reactions').insert({ user_id: u.id, highlight_gid: gid, type: 'like' });
    return sb.from('reactions').delete().eq('user_id', u.id).eq('highlight_gid', gid).eq('type', 'like');
  }

  /* ---- closet (feed ♡ saves) — closet_items, same auth as community.
     product_handle strings; RLS limits every call to the signed-in user. ---- */
  async function closetList() {           /* handles only — kept for any legacy caller */
    var u = await user(); if (!u) return [];
    var r = await sb.from('closet_items')
      .select('product_handle')
      .eq('user_id', u.id)
      .order('saved_at', { ascending: true });
    return (r && r.data ? r.data : []).map(function (x) { return x.product_handle; });
  }
  async function closetListFull() {        /* handle + snapshot columns */
    var u = await user(); if (!u) return [];
    var r = await sb.from('closet_items')
      .select('product_handle, title, brand, price, image_url, product_gone')
      .eq('user_id', u.id)
      .order('saved_at', { ascending: true });
    return (r && r.data) ? r.data : [];
  }
  function closetRow(uid, handle, snap) {
    var row = { user_id: uid, product_handle: handle };
    if (snap) {
      if (snap.title != null)     row.title = snap.title;
      if (snap.brand != null)     row.brand = snap.brand;
      if (snap.price != null)     row.price = snap.price;
      if (snap.image_url != null) row.image_url = snap.image_url;
    }
    return row;
  }
  async function closetAdd(handle, snap) {
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    var r = await sb.from('closet_items').upsert(
      closetRow(u.id, handle, snap),
      { onConflict: 'user_id,product_handle', ignoreDuplicates: true }
    );
    /* the ♡ is the only conversion between "landed" and "clicked out", so it's what
       tells you a channel sends people with taste even when they don't click through.
       logged only on success, and never allowed to fail the save itself. */
    if (!r || !r.error) { try { logEvent('save', handle, snap && snap.brand); } catch (e) {} }
    return r;
  }
  async function closetRemove(handle) {
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    var r = await sb.from('closet_items').delete().eq('user_id', u.id).eq('product_handle', handle);
    /* the mirror of 'save' — without it a channel that saves then un-saves everything
       reads as pure taste. logged on success only, never allowed to fail the removal. */
    if (!r || !r.error) { try { logEvent('unsave', handle); } catch (e) {} }
    return r;
  }
  /* mark a product gone across EVERY holder's closet (security-definer rpc). called when the closet
     renders a dead item, so the gone state persists even after the product is deleted from Shopify
     (and thus drops out of collections.dead). anon-callable; sets product_gone=true only. */
  async function markClosetGone(handle) {
    if (!sb || !handle) return;
    try { return await sb.rpc('mark_closet_gone', { p_handle: handle }); } catch (e) { return; }
  }
  async function closetMerge(items) {      /* accepts ['handle'] OR [{handle, ...snapshot}] */
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    if (!items || !items.length) return { error: null };
    var rows = items.map(function (it) {
      return (typeof it === 'string') ? closetRow(u.id, it, null) : closetRow(u.id, it.handle, it);
    });
    return sb.from('closet_items').upsert(rows,
      { onConflict: 'user_id,product_handle', ignoreDuplicates: true });
  }
  /* public aggregate — how many closets hold this handle. RLS blocks a plain
     count on closet_items, so this calls the security-definer rpc closet_count
     (returns ONLY the integer, never rows). safe for anon; RLS stays intact. */
  async function closetCount(handle) {
    if (!sb || !handle) return 0;
    try {
      var r = await sb.rpc('closet_count', { handle: handle });
      return (r && !r.error && typeof r.data === 'number') ? r.data : 0;
    } catch (e) { return 0; }
  }

  /* ---- comments (tile pages) — public read, authed write, soft-delete.
     joins profiles for @handle ONLY (never email, never member number). ---- */
  async function commentsList(handle) {
    if (!sb || !handle) return [];
    var r = await sb.from('comments')
      .select('id, user_id, body, created_at, profiles ( handle )')
      .eq('product_handle', handle)
      .eq('is_deleted', false)
      .order('created_at', { ascending: false });
    return (r && r.data) ? r.data : [];
  }
  async function commentAdd(handle, body) {
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    var r = await sb.from('comments')
      .insert({ user_id: u.id, product_handle: handle, body: body })
      .select('id, user_id, body, created_at, profiles ( handle )')
      .single();
    /* same shape as the save/signup beacons: log only on success, never let a logging
       failure touch the caller's return value. */
    if (r && !r.error) { try { logEvent('comment', handle); } catch (e) {} }
    return r;
  }
  async function commentDelete(id) {
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    return sb.from('comments').update({ is_deleted: true }).eq('id', id);
  }

  async function submitFind(payload) {
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    payload.user_id = u.id;
    return sb.from('submissions').insert(payload);
  }
  async function mySubmissions() {
    var u = await user(); if (!u) return [];
    var r = await sb.from('submissions')
      .select('title, kind, city, status, created_at')
      .eq('user_id', u.id)
      .order('created_at', { ascending: false });
    return (r && r.data) ? r.data : [];
  }

  /* ---------- "unknowns": a member's private list of pieces they're chasing ----------
     PRIVATE `unknowns` bucket (RLS: own {uid}/ prefix only) + submissions(kind='unknown').
     image_url stores the STORAGE PATH, not a public url — render via createSignedUrl. ---- */
  async function uploadUnknown(file, note) {          /* → { data: row, error } */
    var u = await user(); if (!u) return { error: { message: 'not signed in' } };
    if (!file) return { error: { message: 'no file' } };
    var ext = (file.name && file.name.indexOf('.') > -1)
      ? file.name.split('.').pop().toLowerCase().replace(/[^a-z0-9]/g, '') : 'jpg';
    var path = u.id + '/' + Date.now() + '.' + (ext || 'jpg');   /* {uid}/{timestamp}.{ext} — same shape as uploadAvatar */
    var up = await sb.storage.from('unknowns').upload(path, file,
      { cacheControl: '3600', upsert: false, contentType: file.type || undefined });
    if (up && up.error) return { error: up.error };
    return sb.from('submissions')
      .insert({ user_id: u.id, kind: 'unknown', image_url: path, note: (note || null) })
      .select('id, image_url, note, link, status, admin_note, created_at')
      .single();
  }
  async function myUnknowns() {
    var u = await user(); if (!u) return [];
    var r = await sb.from('submissions')
      .select('id, image_url, note, link, status, admin_note, created_at')
      .eq('user_id', u.id).eq('kind', 'unknown')
      .order('created_at', { ascending: false });
    return (r && r.data) ? r.data : [];
  }
  async function unknownSignedUrl(path, expires) {    /* private bucket → signed url to render the thumb */
    if (!sb || !path) return null;
    try {
      var r = await sb.storage.from('unknowns').createSignedUrl(path, expires || 3600);
      return (r && r.data) ? r.data.signedUrl : null;
    } catch (e) { return null; }
  }
  async function deleteUnknown(id, path) {            /* remove the row (RLS: own) + its private image */
    var u = await user(); if (!u) return { error: { message: 'auth' } };
    if (path) { try { await sb.storage.from('unknowns').remove([path]); } catch (e) {} }
    return sb.from('submissions').delete().eq('id', id).eq('user_id', u.id).eq('kind', 'unknown');
  }

  /* ---------- outbound link-out click logging → public.tile_clicks (insert-only, no reads) ----------
     one shared logger, wired via a delegated capture-phase click listener. every outbound link-out
     button carries data-linkout + data-handle/data-source/data-network; on click we fire a beacon
     BEFORE navigation — non-blocking, survives unload, never preventDefault, no await. internal
     navigation / saves / non-outbound taps have no [data-linkout] and are ignored. */
  var _authToken = null, _authUid = null;
  if (sb) {
    try {
      sb.auth.getSession().then(function (r) {
        var s = r && r.data ? r.data.session : null;
        _authToken = s ? s.access_token : null; _authUid = (s && s.user) ? s.user.id : null;
      }).catch(function () {});
      sb.auth.onAuthStateChange(function (_e, s) {
        _authToken = s ? s.access_token : null; _authUid = (s && s.user) ? s.user.id : null;
      });
    } catch (e) {}
  }
  function clickSessionKey() {
    try {
      var k = localStorage.getItem('mien_sk');
      if (!k) {
        k = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
          : ('sk-' + Date.now() + '-' + Math.random().toString(16).slice(2));
        localStorage.setItem('mien_sk', k);
      }
      return k;
    } catch (e) { return null; }
  }

  /* ---------- traffic attribution (first-touch, sticky) ----------
     the outbound click is the conversion event, but the row only ever carried
     document.referrer — which on a tile page is bemien.com itself. that recorded
     which of OUR pages a click came from, never which channel sent the person, so
     "did pinterest traffic actually click out?" had no answer anywhere.

     this resolves a channel ONCE, at landing, from utm_source + the EXTERNAL
     referrer, and carries it onto every click and save for the life of the browser.
     attribution cannot be backfilled — a visit that arrives unmeasured is gone for
     good — so it runs on every page load, ahead of anything that consumes it.

     vocabulary, kept deliberately distinct:
       visitor_key (mien_sk)  durable in localStorage, one per browser forever.
       visit_key   (mien_vs)  sessionStorage, so a new tab-session is a new visit.
                              this is what approximates an analytics "session".
     tile_clicks.session_key stays the visitor key so the existing admin_click_*
     rpcs keep meaning exactly what they meant before. */
  var VISIT_SS = 'mien_vs', VISIT_SENT_SS = 'mien_vs_sent', ATTR_LS = 'mien_attr';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  /* host → channel. ordered: the shortlink/redirector forms (l.instagram.com,
     pin.it, t.co) must resolve to their parent, not leak through as raw hosts. */
  var CHANNEL_HOSTS = [
    [/(^|\.)pinterest\./i, 'pinterest'], [/^pin\.it$/i, 'pinterest'],
    [/(^|\.)instagram\./i, 'instagram'],
    [/(^|\.)tiktok\./i, 'tiktok'],
    [/(^|\.)facebook\./i, 'facebook'], [/(^|\.)fb\.(com|me)$/i, 'facebook'],
    [/(^|\.)reddit\./i, 'reddit'], [/^redd\.it$/i, 'reddit'],
    [/^t\.co$/i, 'twitter'], [/(^|\.)twitter\./i, 'twitter'], [/^x\.com$/i, 'twitter'],
    [/(^|\.)youtube\./i, 'youtube'], [/^youtu\.be$/i, 'youtube'],
    [/(^|\.)linkedin\./i, 'linkedin'], [/^lnkd\.in$/i, 'linkedin'],
    [/(^|\.)google\./i, 'google'], [/(^|\.)bing\./i, 'bing'],
    [/(^|\.)duckduckgo\./i, 'duckduckgo'], [/(^|\.)yahoo\./i, 'yahoo'],
    [/(^|\.)substack\./i, 'substack'], [/(^|\.)discord\./i, 'discord'],
    [/(^|\.)threads\./i, 'threads'], [/(^|\.)tumblr\./i, 'tumblr']
  ];
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function visitKey() {
    var k = ssGet(VISIT_SS);
    if (!k) { k = newClickId(); ssSet(VISIT_SS, k); }   /* fn declaration — hoisted, safe here */
    return k;
  }
  function clip(s, n) { return (s == null || s === '') ? null : String(s).slice(0, n); }
  function normChannel(s) {
    return String(s || '').trim().toLowerCase().replace(/[^a-z0-9._-]+/g, '-').slice(0, 40) || null;
  }
  function hostOf(url) {
    if (!url) return '';
    /* CAREFUL: `URL` is shadowed inside this IIFE by the supabase project-url string
       constant declared at the top, so a bare `new URL(url)` here constructs a String
       and throws — which would be caught, return '', and silently attribute every
       single visit as 'direct'. reach for the window global explicitly, with an
       anchor-element fallback for anything that lacks it. */
    try {
      var U = (typeof window !== 'undefined') ? window.URL : null;
      if (U) return new U(url).hostname || '';
    } catch (e) {}
    try {
      var a = document.createElement('a'); a.href = url; return a.hostname || '';
    } catch (e) {}
    return '';
  }
  function resolveChannel(ref, qs) {
    if (qs.utm_source) return normChannel(qs.utm_source);   /* explicit tag always wins */
    var h = hostOf(ref);
    if (!h) return 'direct';
    /* our own pages are internal navigation, NOT a new touch — returning null tells
       the caller to keep whatever attribution it already has. this is the single
       most important line here: without it every tile page view would re-stamp
       the visitor as "bemien.com" and destroy the original source. */
    if (/(^|\.)bemien\.com$/i.test(h) || h === location.hostname) return null;
    for (var i = 0; i < CHANNEL_HOSTS.length; i++) {
      if (CHANNEL_HOSTS[i][0].test(h)) return CHANNEL_HOSTS[i][1];
    }
    return normChannel(h.replace(/^www\./i, ''));           /* unknown external → keep the host */
  }
  /* the latest campaign link (?utm_campaign= or ?utm_source=), for the signup record */
  try {
    (function () {
      var p = new URLSearchParams(location.search), src = p.get('utm_source'), camp = p.get('utm_campaign');
      if (src || camp) localStorage.setItem('fly_signup_utm', JSON.stringify({ source: (src || '').slice(0, 80), campaign: (camp || '').slice(0, 120), at: Date.now() }));
    })();
  } catch (e) {}
  function attribution() {
    var cached = null;
    try { cached = JSON.parse(localStorage.getItem(ATTR_LS) || 'null'); } catch (e) {}
    var qs = {};
    try {
      var p = new URLSearchParams(location.search);
      UTM_KEYS.forEach(function (k) { var v = p.get(k); if (v) qs[k] = v.slice(0, 200); });
    } catch (e) {}
    var ch = resolveChannel(document.referrer || '', qs);
    if (ch === null) return cached || { channel: 'direct' };   /* internal nav — never re-stamp */
    if (cached && cached.channel) {
      /* FIRST touch is the one that gets credit, with one deliberate exception: a real
         channel overwrites a bare 'direct', so someone who typed the url once and later
         arrives from a pin is credited to pinterest instead of being stuck as direct. */
      if (cached.channel !== 'direct') return cached;
      if (ch === 'direct') return cached;
    }
    var attr = {
      channel: ch,
      utm_source: clip(qs.utm_source, 120), utm_medium: clip(qs.utm_medium, 120),
      utm_campaign: clip(qs.utm_campaign, 200), utm_content: clip(qs.utm_content, 200),
      utm_term: clip(qs.utm_term, 200),
      referrer: clip(document.referrer, 500),
      landing_path: clip(location.pathname + location.search, 500)
    };
    try { localStorage.setItem(ATTR_LS, JSON.stringify(attr)); } catch (e) {}
    return attr;
  }
  function deviceClass() {
    try { return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ? 'mobile' : 'desktop'; }
    catch (e) { return null; }
  }
  /* one row per visit. the sessionStorage flag stops repeat page loads inside a visit
     from re-posting; the unique index on visit_key is the real backstop.

     DO NOT add Prefer: resolution=ignore-duplicates here. it makes PostgREST treat the
     insert as an UPSERT, and an upsert needs an UPDATE rls policy as well as INSERT —
     this table only has INSERT (by design; letting anon rewrite session rows would make
     the whole attribution table forgeable). with the header the row is rejected outright
     with 42501 "new row violates row-level security policy", which is exactly what
     happened on the first deploy. a plain insert is the proven tile_clicks path. a
     genuine duplicate visit_key would 409 and log a warning, and the sessionStorage
     guard means that effectively never happens. */
  function logSession() {
    try {
      if (ssGet(VISIT_SENT_SS)) return;
      ssSet(VISIT_SENT_SS, '1');
      var a = attribution();
      postRow('mien_sessions', JSON.stringify({
        visit_key: visitKey(),
        visitor_key: clickSessionKey(),
        channel: a.channel || 'direct',
        utm_source: a.utm_source || null, utm_medium: a.utm_medium || null,
        utm_campaign: a.utm_campaign || null, utm_content: a.utm_content || null,
        utm_term: a.utm_term || null,
        referrer: a.referrer || null,
        /* the path THIS visit landed on, which is what tells you whether pins are
           deep-linking to tiles or dumping everyone on the homepage */
        landing_path: clip(location.pathname + location.search, 500),
        device: deviceClass(),
        /* the ONLY thing that lets a crawler be told from an audience after the fact.
           without it the Aug 2026 dashboard counted 214 crawler hits as "direct visits"
           and every rate on /pages/clicks was wrong by ~4x. is_bot_ua() reads this
           server-side; a null UA classifies as unknown, never as bot. */
        user_agent: clip(navigator.userAgent, 500),
        /* frequently null: auth resolves async and most landings are anonymous.
           the visitor_key still stitches the visit to any later signed-in activity. */
        user_id: _authUid || null
      }));
    } catch (e) {}
  }
  /* non-click conversions, so the funnel has a middle. deliberately NOT per-tile
     impressions — 900+ tiles per scroll would make the table useless and expensive.

     event_type is constrained DB-side (mien_events_type). a value outside that list is
     rejected with 23514 and the row is silently lost, so widen the constraint before
     adding a type here. `detail` carries the non-product payload (a filter bucket name);
     product_handle stays a real handle. */
  function logEvent(type, handle, brand, detail) {
    try {
      var a = attribution();
      postRow('mien_events', JSON.stringify({
        event_type: type,
        visit_key: visitKey(), visitor_key: clickSessionKey(),
        channel: a.channel || 'direct',
        product_handle: clip(handle, 200), brand: clip(brand, 120),
        detail: clip(detail, 120),
        user_id: _authUid || null
      }));
    } catch (e) {}
  }
  /* ---------- engagement signals ----------
     the point of these three is to make bought traffic readable. an ad buys visits;
     mien_sessions counts them, tile_clicks counts the ~2% that leave. between those two
     numbers there was nothing, so a bounced visit and an engaged one looked identical
     and there was no way to tell a bot farm from an audience.

     each fires at most ONCE PER VISIT (sessionStorage, same pattern as the visit beacon).
     per-pageview would multiply rows by every scroll and every navigation for no extra
     signal — "did this visit engage at all" is the question being answered. */
  var SCROLL_SENT_SS = 'mien_ev_scroll', TILE_SENT_SS = 'mien_ev_tile', FILT_SENT_SS = 'mien_ev_filt',
      ENGAGED_SENT_SS = 'mien_ev_engaged', SEARCH_SENT_SS = 'mien_ev_search';
  function oncePerVisit(flag) {
    if (ssGet(flag)) return false;
    ssSet(flag, '1');
    return true;
  }
  /* ---------- `engaged`: the load-bearing beacon ----------
     Every other signal here is about WHAT someone did. This one exists to establish
     THAT someone is a someone, and it is what makes click-out rate a real number.

     The classifier behind /pages/clicks needs a denominator of proven humans. Before this
     it had two proofs to work with and both were bad: `scroll` needs 1.5 viewport heights,
     which most real visits never reach, and "clicked out" is circular — clicking is the
     numerator, so a rate built on it returns 100% by construction. This fires on the first
     genuine input of any kind, typically within a second of arrival and well before any
     click, so the denominator is established independently of the thing being measured.

     Deliberately the LOWEST possible bar: one tap, one key, one wheel notch, one pixel of
     scroll. The crawler that polluted Aug 2026 rendered pages and ran JS while spoofing a
     mobile Safari UA — user-agent matching could never have caught it — but it never
     touched anything, and that is the tell this reads.

     isTrusted rejects synthetic events so our own dispatched clicks can't self-verify.
     pointermove is deliberately absent: some mobile browsers emit one on load. */
  try {
    var ENGAGE_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];
    var onEngage = function (ev) {
      try {
        if (ev && ev.isTrusted === false) return;
        ENGAGE_EVENTS.forEach(function (n) {
          document.removeEventListener(n, onEngage, true);
        });
        if (oncePerVisit(ENGAGED_SENT_SS)) logEvent('engaged');
      } catch (e) {}
    };
    ENGAGE_EVENTS.forEach(function (n) {
      document.addEventListener(n, onEngage, { capture: true, passive: true });
    });
  } catch (e) {}
  try {
    /* 1.5 screens is past the fold and past the first grid row on mobile — far enough
       that it cannot be an accidental trackpad nudge, near enough that a genuinely
       interested visitor always trips it.

       CAPTURE phase on document, not a plain window listener: mien.css sets overflow-y
       on `body` in several page-type blocks while line ~1918 gives body height:auto, so
       which element actually scrolls varies by template. scroll events do NOT bubble, so
       a window listener misses any scroller that isn't the viewport — but the capture
       phase still runs window → document → target for non-bubbling events, so this sees
       every one of them. offset is read from whichever element fired rather than assumed.
       passive so it can never block scrolling. */
    var onScroll = function (ev) {
      try {
        var t = ev && ev.target;
        var y = Math.max(
          window.pageYOffset || 0,
          (document.documentElement && document.documentElement.scrollTop) || 0,
          (document.body && document.body.scrollTop) || 0,
          (t && t.scrollTop) || 0
        );
        if (y < (window.innerHeight || 600) * 1.5) return;
        document.removeEventListener('scroll', onScroll, true);
        if (oncePerVisit(SCROLL_SENT_SS)) logEvent('scroll');
      } catch (e) {}
    };
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  } catch (e) {}
  try {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      /* tile opened — the plate is the image link; the handle lives on the tile wrapper */
      var plate = t.closest('a.mfeed-plate');
      if (plate) {
        var tile = plate.closest('[data-handle]');
        if (tile && oncePerVisit(TILE_SENT_SS)) {
          /* feed tiles carry data-brand on the wrapper itself; tile/brand pages put it on a
             descendant button, so fall back rather than assume one shape. */
          var bEl = tile.hasAttribute('data-brand') ? tile : tile.querySelector('[data-brand]');
          logEvent('tile_open', tile.getAttribute('data-handle'), bEl && bEl.getAttribute('data-brand'));
        }
        return;
      }
      /* filter used — colour swatches carry data-col, category pills data-cat. both live
         in the header sidebar on every page, so one delegated listener covers the site. */
      var sw = t.closest('[data-col],[data-cat]');
      if (sw && oncePerVisit(FILT_SENT_SS)) {
        var col = sw.getAttribute('data-col');
        logEvent('filter', null, null, col ? 'color:' + col : 'cat:' + sw.getAttribute('data-cat'));
      }
    }, true);
  } catch (e) {}
  /* ---------- search ----------
     Read off the URL on load rather than hooked to the input, because every committed
     search is a real navigation to /search?q= — the header form submits there and the
     typeahead's suggestions are links. One listener would have to live in three files to
     catch the same thing this catches for free.

     Deduped per query per visit, NOT oncePerVisit: refining a search is the interesting
     behaviour and collapsing "hat" then "beanie" into one row would hide it. Re-running the
     SAME query (back button, pagination, infinite scroll re-entry) is noise and is dropped.

     KNOWN GAP, stated on the coverage panel rather than papered over: a typeahead that is
     opened, read and abandoned without navigating leaves no trace here. */
  try {
    if (/^\/search/.test(location.pathname)) {
      var qterm = '';
      try { qterm = (new URLSearchParams(location.search).get('q') || '').trim(); } catch (e) {}
      if (qterm) {
        /* the flag key carries the query, so each distinct term gets its own once-guard */
        var qflag = 'mien_ev_q_' + qterm.slice(0, 60).toLowerCase();
        if (oncePerVisit(qflag)) logEvent('search', null, null, qterm);
      }
    }
  } catch (e) {}
  /* ---------- dead tiles ----------
     Link rot is the quiet failure mode of a feed that points at other people's stores: a
     tile keeps earning taps long after the brand pulled the product. window.MIEN_DEAD is
     already on every page (theme.liquid, server-rendered from the `dead` collection), so
     this costs one array lookup and turns rot into something the dashboard can rank. */
  function deadHandles() { try { return window.MIEN_DEAD || []; } catch (e) { return []; } }
  try {
    var pm = location.pathname.match(/^\/products\/([^\/?#]+)/);
    if (pm && deadHandles().indexOf(pm[1]) > -1) logEvent('dead', pm[1]);
  } catch (e) {}
  /* one insert-only beacon shared by tile_clicks / mien_sessions / mien_events.
     fetch(keepalive) is the PRIMARY path — it sets apikey + Authorization (proper CORS) AND
     survives the page unload, so it works for both new-tab (target=_blank) and same-tab link-outs.
     NOTE: sendBeacon is NOT usable here — a Blob of type application/json is a non-simple cross-
     origin request, which needs a CORS preflight that sendBeacon can't send, so the beacon dies the
     CORS check silently (and returns true, which previously skipped this fetch). that empty
     tile_clicks table was this bug. */
  function postRow(table, body, prefer) {
    var endpoint = URL + '/rest/v1/' + table;
    try {
      var token = _authToken || KEY;
      fetch(endpoint, {
        method: 'POST', keepalive: true, cache: 'no-store', mode: 'cors',
        headers: {
          'apikey': KEY, 'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json', 'Prefer': prefer || 'return=minimal'
        },
        body: body
      }).then(function (r) {
        /* surface failures instead of swallowing them — non-blocking, never affects navigation */
        if (r && !r.ok) {
          r.text().then(function (t) {
            try { console.warn('[mien] ' + table + ' log failed', r.status, t); } catch (e) {}
          }, function () { try { console.warn('[mien] ' + table + ' log failed', r.status); } catch (e) {} });
        }
      }, function (err) { try { console.warn('[mien] ' + table + ' log failed', 'network', err); } catch (e) {} });
    } catch (e) {}
  }
  function sendClick(body) { postRow('tile_clicks', body); }
  /* ---------- per-click id ----------
     minted HERE, in the browser, before navigation — so the very same value can be pushed
     into the outbound url and stored on the row. that is the whole trick behind affiliate
     reconciliation: a network's commission report carries the subid it was sent, and this
     is the only id that exists on both sides. tile_clicks.id can't do it (server-side,
     generated after the row arrives).

     to use it, put the literal {click_id} anywhere in a brand's affiliate url, e.g.
       https://brand.com/product?utm_source=mien&subid={click_id}
     stampClickId below swaps it for the real uuid at click time, in both the href the
     browser is about to follow and the destination we log. no placeholder = no rewrite,
     so every existing link keeps working untouched. */
  function newClickId() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    } catch (e) {}
    /* uuid v4 shape, so the column stays a real uuid on browsers without randomUUID */
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
  }
  /* the placeholder survives url-encoding, so match both raw and percent-encoded forms.
     built fresh per call rather than shared — a /g regex carries lastIndex between uses. */
  function hasClickToken(url) {
    return !!url && /\{click_id\}|%7Bclick_id%7D/i.test(url);
  }
  function stampClickId(url, id) {
    if (!url) return url;
    return url.replace(/\{click_id\}|%7Bclick_id%7D/gi, encodeURIComponent(id));
  }

  function logTileClick(btn, clickId) {
    try {
      if (!btn) return;
      /* log the RAW merchant destination (data-dest), NOT the viglink / EPN wrapper now in href —
         the report needs to show where people actually land. fall back to href for legacy buttons. */
      var dest = btn.getAttribute('data-dest') || btn.href || btn.getAttribute('href') || btn.getAttribute('data-href') || null;
      if (!dest) return;
      var cid = clickId || newClickId();
      dest = stampClickId(dest, cid);
      /* tile_clicks.submission_id is a uuid column; source_ref on affiliate/eBay tiles is often free
         text ("eBay Partner Network — campaign …", "kapital-ebay-1"), which 400s the insert on invalid
         uuid syntax. only send it when it's a well-formed uuid, else null — no data is lost, the eBay
         customid already lives inside destination_url. */
      var ref = btn.getAttribute('data-ref') || '';
      var refUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(ref) ? ref : null;
      var attr = attribution() || { channel: 'direct' };
      sendClick(JSON.stringify({
        product_handle: btn.getAttribute('data-handle') || null,
        destination_url: dest,
        /* the vendor, carried on the button — so "how did parra do this week" is one query
           against this table instead of a join back to shopify */
        brand: btn.getAttribute('data-brand') || null,
        click_id: cid,
        source: btn.getAttribute('data-source') || null,
        network: btn.getAttribute('data-network') || null,
        /* uuid source_ref only (community submissions) → reconciles tile_clicks against sovrn's CUID report */
        submission_id: refUuid,
        /* fly blocks (feed link-outs, "pieces like this") carry their block id here, never in data-ref:
           submission_id points at seller_products, so a block id there failed the insert */
        block_id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(btn.getAttribute('data-block') || '') ? btn.getAttribute('data-block') : null,
        /* a tap on a post's matched piece: the post it came from (2026-10-27), so its poster sees what it led to */
        from_block_id: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(btn.getAttribute('data-from-block') || '') ? btn.getAttribute('data-from-block') : null,
        user_id: _authUid || null,
        session_key: clickSessionKey(),
        /* NOTE: this stays document.referrer — the INTERNAL page the click came from,
           which is genuinely useful (homepage vs tile page vs brand page). the traffic
           source is the separate `channel` field below; conflating the two is what made
           this column read 100% "https://bemien.com/" and answer nothing. */
        referrer: document.referrer || null,
        user_agent: navigator.userAgent,
        /* attribution carried onto the click itself rather than only joined via
           visit_key: click logging is fire-and-forget and the session beacon can fail
           independently, so denormalising keeps per-channel cuts correct even when the
           matching mien_sessions row never landed. */
        visit_key: visitKey(),
        channel: attr.channel || 'direct',
        utm_source: attr.utm_source || null,
        utm_medium: attr.utm_medium || null,
        utm_campaign: attr.utm_campaign || null,
        landing_path: attr.landing_path || null
      }));
    } catch (e) {}
  }
  try {
    document.addEventListener('click', function (e) {
      var btn = (e.target && e.target.closest) ? e.target.closest('[data-linkout]') : null;
      if (!btn) return;
      var cid = newClickId();
      /* CAPTURE phase, before the default action: rewriting href here means the browser
         follows the stamped url — true for same-tab and for target="_blank" alike, since
         the href is read at activation. the un-stamped template is kept on the element so
         a SECOND click re-stamps from it with a fresh id; stamping in place would leave
         every repeat click carrying the first click's subid. */
      try {
        var tpl = btn.getAttribute('data-href-tpl');
        if (tpl === null) {
          tpl = btn.getAttribute('href') || '';
          btn.setAttribute('data-href-tpl', tpl);
        }
        if (tpl && hasClickToken(tpl)) {
          btn.setAttribute('href', stampClickId(tpl, cid));
        } else if (tpl && /^https?:/i.test(tpl) && tpl.indexOf('subid=') === -1) {
          /* the server now strips "subid={click_id}" from hrefs (mien-affiliate-href) so a
             copied link never carries literal braces — the real subid is appended HERE, with
             the same id logTileClick writes to tile_clicks, at the moment of the click. */
          btn.setAttribute('href', tpl + (tpl.indexOf('?') > -1 ? '&' : '?') + 'subid=' + encodeURIComponent(cid));
        }
      } catch (err) {}
      logTileClick(btn, cid); /* fire-and-forget — never preventDefault, never delay navigation */
      /* same event, second consumer: our own dashboard reads tile_clicks, the ad platforms
         read this. mirroring the outbound click into the pixels is what lets meta/pinterest
         optimise for people who actually tap through instead of for cheap landing-page
         views. MienAds only exists when at least one pixel id is configured, and every
         platform inside it is individually try/caught, so this can never affect the click. */
      try {
        if (window.MienAds && window.MienAds.outboundClick) {
          window.MienAds.outboundClick({
            handle: btn.getAttribute('data-handle'),
            brand: btn.getAttribute('data-brand')
          });
        }
      } catch (err) {}
    }, true);
  } catch (e) {}

  /* ---------- INTERNAL TILE CLICKS (2026-08-29) ----------
     mien is native checkout only now: the outbound click that tile_clicks was built around
     no longer exists on a piece we sell. The table, the click_id, the attribution columns
     and every panel on /pages/clicks stay exactly as they are — what changes is WHAT counts
     as the click. The equivalent moment of intent is now the tap from a feed tile through to
     the product page, so that is what gets logged, with source='internal' and the product's
     own url as the destination.

     Why the same table rather than a new one: "which brand is paid traffic actually opening"
     is the question /pages/clicks answers, and it has to keep answering it across the
     retirement. source='internal' vs the historic 'curated'/'community'/'partner' values is
     what separates the two eras in a query.

     A native product page reached any other way (search, a shared link, the closet) is NOT
     logged here — that is a visit, and mien_sessions already has it. Only the tile tap. */
  try {
    var _lastTileClick = { h: null, t: 0 };
    document.addEventListener('click', function (e) {
      var a = (e.target && e.target.closest) ? e.target.closest('a.mfeed-plate') : null;
      if (!a) return;
      var tile = a.closest('.mfeed-tile');
      var handle = (tile && tile.getAttribute('data-handle')) || null;
      if (!handle) return;
      /* an echo clone of a tile and its original share a handle; a double-tap on a phone
         fires twice. one row per handle per second is the honest count. */
      var now = Date.now();
      if (_lastTileClick.h === handle && now - _lastTileClick.t < 1000) return;
      _lastTileClick = { h: handle, t: now };

      var attr = attribution() || { channel: 'direct' };
      var href = a.getAttribute('href') || ('/products/' + handle);
      sendClick(JSON.stringify({
        product_handle: handle,
        destination_url: (location.origin || '') + href,
        brand: (tile && tile.getAttribute('data-brand')) || null,
        click_id: newClickId(),
        source: 'internal',
        network: null,
        submission_id: null,
        user_id: _authUid || null,
        session_key: clickSessionKey(),
        referrer: document.referrer || null,
        user_agent: navigator.userAgent,
        visit_key: visitKey(),
        channel: attr.channel || 'direct',
        utm_source: attr.utm_source || null,
        utm_medium: attr.utm_medium || null,
        utm_campaign: attr.utm_campaign || null,
        landing_path: attr.landing_path || null
      }));
    }, true);
  } catch (e) {}

  /* fire the visit beacon immediately. no DOM wait: it only reads location +
     document.referrer, both available at parse time, and referrer is exactly what
     we'd risk losing by deferring. wrapped so a storage/network failure here can
     never take down the rest of the MIEN api. */
  try { logSession(); } catch (e) {}

  return {
    ready: ready, sb: sb, url: URL, key: KEY, logTileClick: logTileClick,
    attribution: attribution, signupMeta: signupMeta, visitKey: visitKey, logEvent: logEvent,
    session: session, user: user,
    signUp: signUp, signIn: signIn, signOut: signOut, onChange: onChange,
    resetPassword: resetPassword, updatePassword: updatePassword,
    outletPrices: outletPrices,
    profile: profile, onboardingState: onboardingState, setHandle: setHandle, setProfile: setProfile, uploadAvatar: uploadAvatar,
    counts: counts, mySaves: mySaves, myReactions: myReactions,
    toggleSave: toggleSave, toggleReaction: toggleReaction,
    closetList: closetList, closetListFull: closetListFull, closetAdd: closetAdd, closetRemove: closetRemove, closetMerge: closetMerge, closetCount: closetCount, markClosetGone: markClosetGone,
    commentsList: commentsList, commentAdd: commentAdd, commentDelete: commentDelete,
    submitFind: submitFind, mySubmissions: mySubmissions,
    uploadUnknown: uploadUnknown, myUnknowns: myUnknowns, unknownSignedUrl: unknownSignedUrl, deleteUnknown: deleteUnknown
  };
})();
